/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationDto } from '../../models/application-dto';

export interface EventClientControllerApplyEventV1$Params {
  id: string;
}

export function eventClientControllerApplyEventV1(http: HttpClient, rootUrl: string, params: EventClientControllerApplyEventV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationDto>> {
  const rb = new RequestBuilder(rootUrl, eventClientControllerApplyEventV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplicationDto>;
    })
  );
}

eventClientControllerApplyEventV1.PATH = '/api/v1/events/client/{id}/apply';
